import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import { useDispatch } from 'react-redux';
import useAuth from '../hooks/useAuth';
import './Home.css'; // Import your custom CSS file

const Home = () => {
    const dispatch = useDispatch();
    const auth = useAuth(dispatch);

    // Determine if we're in staging or production based on the current environment
    const isStaging = window.location.hostname.includes('stage') ||
        window.location.hostname.includes('localhost') ||
        process.env.NODE_ENV === 'development';

    const onlineExamUrl = isStaging
        ? 'https://ngauge-stage.appliedpractice.com/online-exam/'
        : 'https://ngauge.appliedpractice.com/online-exam';

    if (auth) {
        if (auth.isAdmin) return <Redirect to='/admin' />;
        else if (auth.isTeacher) return <Redirect to='/teacher' />;
        else if (auth.isReader) return <Redirect to='/reader' />;
        else if (auth.isStudent) {
            window.location.href = onlineExamUrl;
            return null;
        }
    }

    return (
        <div className='home-container'>
            <Container className='text-center'>
                <img
                    src={`${process.env.PUBLIC_URL}/icons/Image_ nGauge Update.png`}
                    alt='nGauge Update'
                    className='header-icon'
                />
                <h1>nGauge Testing Platform</h1>
                <Row className='home-options'>
                    <Col md={{size: 6, offset: 3}}>
                        <a
                            href={onlineExamUrl}
                            className='home-option'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/icons/Image_ Student Digital.png`}
                                alt='Student Portal Login'
                                className='icon'
                            />
                            <div>Student Portal Login – Fully Digital and Digital Hybrid Exams</div>
                        </a>
                    </Col>
                </Row>
                <Row className='home-options'>
                    <Col md={{size: 6, offset: 3}}>
                        <Link to='/login' className='home-option'>
                            <img
                                src={`${process.env.PUBLIC_URL}/icons/Image_ Admin Dashboard.png`}
                                alt='Teacher Dashboard and Admin/Evaluator Login'
                                className='icon'
                            />
                            <div>Teacher Dashboard and Admin/Evaluator Login</div>
                        </Link>
                    </Col>
                </Row>
                <p className='contact-email'>
                    <a href='mailto:info@appliedpractice.com'>info@appliedpractice.com</a>
                </p>
            </Container>
        </div>
    );
};

export default Home;
